import {
    ADD_FAVOURITE_EMP,
    ADD_FAVOURITE_EMP_SUCCESS,
    FETCH_ALL_EMP,
    FETCH_ALL_EMP_SUCCESS,
    FETCH_EMP_SURVEY_ANSWERS,
    FETCH_EMP_SURVEY_ANSWERS_SUCCESS,
    FILTER_EMP,
    GET_ALL_EMP,
    GET_UNSELECTED_ALL_EMP,
    HANDLE_EMP_REQUEST_CLOSE,
    HIDE_EMP_LOADER,
    SHOW_EMP_LOADER,
    HIDE_EMP_DASHBOARD_LOADER,
    SHOW_EMP_DASHBOARD_LOADER,
    ON_ADD_EMP,
    ON_ALL_EMP_SELECT,
    ON_EMP_CLOSE,
    ON_EMP_SELECT,
    ON_DELETE_EMP,
    ON_DELETE_SELECTED_EMP,
    ON_FILTER_EMP_OPTION_SELECT,
    ON_SAVE_EMP,
    ON_SAVE_EMP_SUCCESS,
    ON_TOGGLE_EMP_DRAWER,
    SHOW_EMP_MESSAGE,
    UPDATE_SEARCH_EMP,
    SAVE_EMP_SURVEY_ANSWERS,
    FETCH_NOTIFICATIONS,
    FETCH_NOTIFICATIONS_SUCCESS,
} from 'constants/ActionTypes';

export const fetchNotifications = (payload) => {
    return {
        type: FETCH_NOTIFICATIONS,
        payload
    };
};
export const fetchNotificationsSuccess = (payload) => {
    return {
        type: FETCH_NOTIFICATIONS_SUCCESS,
        payload,
    };
};
export const fetchEmps = () => {
    return {
        type: FETCH_ALL_EMP
    };
};
export const fetchEmpsSuccess = (emps) => {
    return {
        type: FETCH_ALL_EMP_SUCCESS,
        payload: emps
    };
};
export const showEmpMessage = (message) => {
    return {
        type: SHOW_EMP_MESSAGE,
        payload: message
    };
};
export const addFavouriteEmp = (data) => {
    return {
        type: ADD_FAVOURITE_EMP,
        payload: data
    };
};
export const addFavouriteEmpSuccess = (payload) => {
    return {
        type: ADD_FAVOURITE_EMP_SUCCESS,
        payload
    };
};
export const onEmpSelect = (data) => {
    return {
        type: ON_EMP_SELECT,
        payload: data
    };
};
export const onAddEmp = () => {
    return {
        type: ON_ADD_EMP,
        payload: ''
    };
};
export const onEmpClose = () => {
    return {
        type: ON_EMP_CLOSE,
        payload: ''
    };
};
export const onFilterEmpOptionSelect = (option) => {
    return {
        type: ON_FILTER_EMP_OPTION_SELECT,
        payload: option
    };
};
export const onSaveEmp = (data) => {
    return {
        type: ON_SAVE_EMP,
        payload: data
    };
};
export const onSaveEmpSuccess = (data) => {
    return {
        type: ON_SAVE_EMP_SUCCESS,
        payload: data
    };
};
export const onDeleteEmp = (data) => {
    return {
        type: ON_DELETE_EMP,
        payload: data
    };
};
export const onDeleteSelectedEmp = () => {
    return {
        type: ON_DELETE_SELECTED_EMP,
        payload: ''
    };
};
export const filterEmp = (userName) => {
    return {
        type: FILTER_EMP,
        payload: userName
    };
};
export const getAllEmp = () => {
    return {
        type: GET_ALL_EMP,
        payload: ''
    };
};
export const getUnselectedAllEmp = () => {
    return {
        type: GET_UNSELECTED_ALL_EMP,
        payload: ''
    };
};
export const onAllEmpSelect = () => {
    return {
        type: ON_ALL_EMP_SELECT,
        payload: ''
    };
};
export const updateSearchEmp = (userName) => {
    return {
        type: UPDATE_SEARCH_EMP,
        payload: userName
    };
};
export const onToggleEmpDrawer = () => {
    return {
        type: ON_TOGGLE_EMP_DRAWER,
    };
};
export const handleEmpRequestClose = () => {
    return {
        type: HANDLE_EMP_REQUEST_CLOSE,
    };
};
export const showEmpLoader = () => {
    return {
        type: SHOW_EMP_LOADER,
    };
};
export const hideEmpLoader = () => {
    return {
        type: HIDE_EMP_LOADER,
    };
};
export const fetchEmpSurveyAnswers = (payload) => {
    return {
        type: FETCH_EMP_SURVEY_ANSWERS,
        payload
    };
};
export const fetchEmpSurveyAnswersSuccess = (payload) => {
    return {
        type: FETCH_EMP_SURVEY_ANSWERS_SUCCESS,
        payload
    };
};
export const saveEmpSurveyAnswers = (payload) => {
    return {
        type: SAVE_EMP_SURVEY_ANSWERS,
        payload
    };
};
export const showEmpDashboardLoader = () => {
    return {
        type: SHOW_EMP_DASHBOARD_LOADER,
    };
};
export const hideEmpDashboardLoader = () => {
    return {
        type: HIDE_EMP_DASHBOARD_LOADER,
    };
};
// use onSaveOrgSuveryAnswers to save employee survey results



// WEBPACK FOOTER //
// ./actions/Employee.js